import { RehabilitationClinic } from '@dreryk/egabinet-referral-frontend-api';

import { createBooleanSchema, createNumberSchema, createObjectSchema, createStringSchema } from '@dreryk/react-draft';

import { diagnosesWithBodySideFormPart } from '~libs.desktop.shared.visit-medical-documents.diagnoses';

import { ReferralFormBean } from './shared/common.types';

export type PaperReferralDraftToken =
   | 'referralToHospital'
   | 'referralToSpecialist'
   | 'referralToDiagnosticExamination'
   | 'referralToRehabilitation'
   | 'referralToPsychiatricHospital'
   | 'referralToAnalyticalExamination';

type ElectronicReferralDraftToken =
   | 'electronicReferralToHospital'
   | 'electronicReferralToSpecialist'
   | 'electronicReferralToDiagnosticExamination';

type ReferralDraftToken = PaperReferralDraftToken | ElectronicReferralDraftToken;

type VisitId = number;
export const getReferralDraftToken = (
   referralDraftToken: ReferralDraftToken,
   visitId: VisitId
): `visit-${VisitId}-${typeof referralDraftToken}` => `visit-${visitId}-${referralDraftToken}`;

export const referralCommonDraftSchema = createObjectSchema<ReferralFormBean>({
   cito: createBooleanSchema(),
   diagnoses: diagnosesWithBodySideFormPart.draftSchema,
});

export const rehabilitationClinicSchema = createObjectSchema<RehabilitationClinic>({
   code: createStringSchema(),
   id: createNumberSchema(),
   name: createStringSchema(),
});
